import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  formControl: {
    margin: 0,
    minWidth: 130,
    padding: 0,
    "& .MuiInputBase-root": {
      height: "36px",
      borderRadius: "10px",
      backgroundColor: "rgba(77, 18, 119, 0.03)",
      border: "1px solid rgba(77, 18, 119, 0.08)",
      transition: "all 0.2s ease-in-out",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: 500,
      color: "#272525",
      "&:hover": {
        backgroundColor: "rgba(77, 18, 119, 0.05)",
        borderColor: "rgba(77, 18, 119, 0.2)",
      },
      "&.Mui-focused": {
        backgroundColor: "#fff",
        borderColor: "#4D1277",
        boxShadow: "0 0 0 3px rgba(77, 18, 119, 0.1)",
      },
      "& .MuiSelect-select": {
        paddingLeft: "12px",
        paddingRight: "32px !important",
        display: "flex",
        alignItems: "center",
      },
      "& fieldset": {
        border: "none",
      },
    },
  },
  menu: {
    "& .MuiPaper-root": {
      borderRadius: "12px",
      marginTop: "8px",
      minWidth: "150px",
      boxShadow: "0 10px 25px rgba(77, 18, 119, 0.15)",
      border: "1px solid rgba(77, 18, 119, 0.08)",
      backdropFilter: "blur(20px)",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
    },
    "& .MuiList-root": {
      padding: "6px",
    },
    "& .MuiMenuItem-root": {
      borderRadius: "8px",
      margin: "2px 0",
      fontSize: "13px",
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "#555",
      transition: "all 0.2s",
      "&:hover": {
        backgroundColor: "rgba(77, 18, 119, 0.05)",
        color: "#4D1277",
      },
      "&.Mui-selected": {
        backgroundColor: "rgba(77, 18, 119, 0.08)",
        color: "#4D1277",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "rgba(77, 18, 119, 0.12)",
        },
      },
    },
  },
  icon: {
    right: "10px",
    fontSize: "18px",
    color: "#4D1277",
    transition: "transform 0.2s",
    pointerEvents: "none",
  },
}));

export default useStyles;
